import React from 'react'
import { defaultPollingInterval } from 'src/services'
import { NetworkStatus } from 'apollo-client'
import { useQuery } from 'react-apollo'

/**
 * Wrapper around the official `useQuery` method that automatically pass heaser "Polling" to `true` after the first request
 *
 * @param {import('graphql').DocumentNode} query
 * @param {import('react-apollo').QueryHookOptions} options
 * @return {import('react-apollo').QueryResult}
 */
export default function usePollingQuery(query, options = {}) {
  // get original context
  const { context = {} } = options

  // get original headers
  const { headers = {} } = context

  // create custom headers with Polling state
  const [Polling, setPolling] = React.useState(false)

  // execute query
  const result = useQuery(query, {
    fetchPolicy: 'network-only',
    pollInterval: defaultPollingInterval,
    ...options,
    notifyOnNetworkStatusChange: true, // re-render after each network status change
    context: { ...context, headers: { ...headers, Polling } },
  })

  // get networkStatus and data
  const { networkStatus, loading, data } = result

  // set loading only if no data
  result.loading = data ? false : loading

  // change Polling state on networkStatus change
  React.useEffect(() => setPolling([NetworkStatus.ready, NetworkStatus.poll].includes(networkStatus)), [networkStatus])

  // return query result
  return result
}
